"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TRUCK_DATA = exports.DEFAULT_ROUTING_DATA = exports.DEFAULT_DASHBOARD_DATA = void 0;
var DEFAULT_DASHBOARD_DATA = {
  zone: 0,
  location: 0,
  availableOrder: 0,
  completedOrder: 0
};
exports.DEFAULT_DASHBOARD_DATA = DEFAULT_DASHBOARD_DATA;
var DEFAULT_ROUTING_DATA = {
  code: null,
  orderId: [],
  truckId: [],
  planId: [],
  data: []
};
exports.DEFAULT_ROUTING_DATA = DEFAULT_ROUTING_DATA;
var DEFAULT_TRUCK_DATA = {
  zone: null,
  truckCommodityType: null,
  plateNumber: null,
  workingHours: null,
  locked: false,
  truckId: null,
  capacity1: 0,
  capacity2: 0,
  capacity3: 0,
  estimatedCapacity1: 0,
  estimatedCapacity2: 0,
  estimatedCapacity3: 0,
  estimatedDistance: 0,
  estimatedTime: 0,
  driverId: [],
  projectCode: [],
  routes: [],
  orderId: [],
  shipmentReference: [],
  planId: []
};
exports.DEFAULT_TRUCK_DATA = DEFAULT_TRUCK_DATA;